import React, { useContext, useEffect } from 'react';
import CollaborateQAContext from '../../ContextFiles/CollaborateQAContext';

const MANAGED_CUSTOMER_USERNAME = localStorage.getItem('managed_customer_username');
const MANAGED_COMPANY_ID = localStorage.getItem('managed_company_id');
const IS_MS_PROVIDER = localStorage.getItem("is_msprovider") === 'true' ? true : false;

function preventScroll(e) {
  const isInsideAnnotateBox = e.target.closest('.annotate-box');
  const isInsideCommentBox = e.target.closest('.comment-history-drawer');
  if (isInsideAnnotateBox || isInsideCommentBox) return;

  e.preventDefault();
}

const CollaborateQACanvas = () => {
    const { initialLoader, access_level, selected_action, projectID, productData, hideProductBanner } = useContext(CollaborateQAContext);

    useEffect(() => {
        const canvasEl = document.getElementById('canvas-editor-qa');
        const scrollContainer = document.querySelector('.gx-layout-content');
      
        if (!canvasEl) return;
      
        let isInsideCanvas = false;
      
        const checkMousePosition = (e) => {
          const rect = canvasEl.getBoundingClientRect();
          const isNowInside =
            e.clientX >= rect.left &&
            e.clientX <= rect.right &&
            e.clientY >= rect.top &&
            e.clientY <= rect.bottom;
      
          if (isNowInside && !isInsideCanvas) {
            isInsideCanvas = true;
            console.log('Entered canvas');
            if (scrollContainer) {

                // Keep overflow scroll so scrollbar is visible
                scrollContainer.style.overflow = 'auto'; // or 'scroll'

                // Disable scroll interactions (wheel, touchpad, pinch)
                scrollContainer.addEventListener('wheel', preventScroll, { passive: false });
                scrollContainer.addEventListener('touchmove', preventScroll, { passive: false });
                scrollContainer.addEventListener('gesturestart', preventScroll, { passive: false });
            }
            // scrollContainer.style.overflow = 'hidden';
          } else if (!isNowInside && isInsideCanvas) {
            isInsideCanvas = false;
            console.log('Left canvas');
            if (scrollContainer) {
              console.log('YES')
                // Clean up: remove scroll-blocking listeners
                scrollContainer.removeEventListener('wheel', preventScroll);
                scrollContainer.removeEventListener('touchmove', preventScroll);
                scrollContainer.removeEventListener('gesturestart', preventScroll);

                // Restore default overflow behavior
                scrollContainer.style.overflow = 'auto';
            }
            // scrollContainer.style.overflow = '';
          }
        };
      
        document.addEventListener('mousemove', checkMousePosition);
      
        return () => {
          document.removeEventListener('mousemove', checkMousePosition);
          if (scrollContainer) scrollContainer.style.overflow = '';
        };
      }, []);
      
      

      
    return (
        <div id="collaborate-container" className={`collaborate-container ${(["co-owner", "owner"].includes(access_level) || (projectID && access_level == "edit")) ? `qa` : `qa-editor`} ${initialLoader  || (!(IS_MS_PROVIDER && (productData.customer_username == MANAGED_CUSTOMER_USERNAME || productData.company_id == MANAGED_COMPANY_ID)) && access_level == "restricted") ? `blur-canvas` : ``}`}>
            <div id={`fabric-canvas`} className={`fabric-container ${selected_action}`}>
                <canvas id="canvas-editor-qa"></canvas>
            </div>
        </div>
    );
}


export default CollaborateQACanvas;
